import { render, staticRenderFns } from "./StakeDetail.vue?vue&type=template&id=c4993220&scoped=true&"
import script from "./StakeDetail.vue?vue&type=script&lang=js&"
export * from "./StakeDetail.vue?vue&type=script&lang=js&"
import style0 from "./StakeDetail.vue?vue&type=style&index=0&id=c4993220&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4993220",
  null
  
)

export default component.exports